import React from "react";

export const Marquee = ({ text = "ATHLETIC DATA SOLUTIONS", separator = "—" }) => {
  const item = (
    <span className="text-stroke font-display font-black uppercase text-6xl sm:text-7xl md:text-8xl px-6 tracking-tight">
      {text} <span className="text-orange" style={{ WebkitTextStroke: "0" }}>{separator}</span>
    </span>
  );
  return (
    <div className="relative overflow-hidden py-10 border-y border-white/10 bg-dark" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[...Array(4)].map((_, i) => (
          <React.Fragment key={i}>{item}</React.Fragment>
        ))}
      </div>
    </div>
  );
};
